import { render, staticRenderFns } from "./artifact_delete_modal.vue?vue&type=template&id=0199dd9c"
import script from "./artifact_delete_modal.vue?vue&type=script&lang=js"
export * from "./artifact_delete_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports